/** A stage's sources: the draft's intake files, whether the stage used each, and why not. */

import { get } from "@/services/api-client";
import type { SourceResponse, SourceStage } from "@patent-studio/api-types";

export function readSources(
  taskId: string,
  stage: SourceStage,
): Promise<SourceResponse[]> {
  return get<SourceResponse[]>(`/tasks/${taskId}/sources?stage=${stage}`);
}
